import { Plus, X } from "lucide-react";

interface StringListEditorProps {
  label: string;
  values: string[];
  onChange: (values: string[]) => void;
  placeholder?: string;
  addLabel?: string;
}

// Reusable editor for a flat list of strings (items, zones, slots, options).
const StringListEditor = ({
  label,
  values,
  onChange,
  placeholder,
  addLabel = "Add",
}: StringListEditorProps) => {
  const update = (i: number, v: string) => {
    const next = [...values];
    next[i] = v;
    onChange(next);
  };
  const remove = (i: number) => onChange(values.filter((_, idx) => idx !== i));
  const add = () => onChange([...values, ""]);

  return (
    <div className="space-y-2">
      <label className="block font-medium text-burntBlack text-sm">
        {label}
      </label>
      {values.length === 0 && (
        <p className="text-xs text-gray-400">None yet</p>
      )}
      {values.map((v, i) => (
        <div key={i} className="flex items-center gap-2">
          <input
            type="text"
            value={v}
            placeholder={placeholder}
            onChange={(e) => update(i, e.target.value)}
            className="flex-1 h-10 px-3 border border-gray-300 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-blue-400"
          />
          <button
            type="button"
            onClick={() => remove(i)}
            className="flex-shrink-0 p-2 text-gray-400 hover:text-red-500"
            title="Remove"
          >
            <X size={16} />
          </button>
        </div>
      ))}
      <button
        type="button"
        onClick={add}
        className="inline-flex items-center gap-1 text-sm text-[#4379EE] hover:underline"
      >
        <Plus size={14} /> {addLabel}
      </button>
    </div>
  );
};

export default StringListEditor;
